import React from 'react';
import { LargeErrorMessage } from '../shared/other/ErrorMessage';

export function NotFound404Page()
{
	return (
		<LargeErrorMessage message="Oops, could not find the page you're looking for." />
	);
};